/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { SDKError } from "./sdkerror.js";

/**
 * Rate limited
 */
export type CreateTeamAuthTeamsResponse429ResponseBodyData = {
  message: string;
};

/**
 * Rate limited
 */
export class CreateTeamAuthTeamsResponse429ResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: CreateTeamAuthTeamsResponse429ResponseBodyData;

  constructor(
    err: CreateTeamAuthTeamsResponse429ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "CreateTeamAuthTeamsResponse429ResponseBody";
  }
}

/**
 * Conflict
 */
export type CreateTeamAuthTeamsResponse409ResponseBodyData = {
  message: string;
};

/**
 * Conflict
 */
export class CreateTeamAuthTeamsResponse409ResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: CreateTeamAuthTeamsResponse409ResponseBodyData;

  constructor(
    err: CreateTeamAuthTeamsResponse409ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "CreateTeamAuthTeamsResponse409ResponseBody";
  }
}

/**
 * Not found
 */
export type CreateTeamAuthTeamsResponse404ResponseBodyData = {
  message: string;
};

/**
 * Not found
 */
export class CreateTeamAuthTeamsResponse404ResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: CreateTeamAuthTeamsResponse404ResponseBodyData;

  constructor(
    err: CreateTeamAuthTeamsResponse404ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "CreateTeamAuthTeamsResponse404ResponseBody";
  }
}

/**
 * Forbidden
 */
export type CreateTeamAuthTeamsResponseResponseBodyData = {
  message: string;
};

/**
 * Forbidden
 */
export class CreateTeamAuthTeamsResponseResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: CreateTeamAuthTeamsResponseResponseBodyData;

  constructor(
    err: CreateTeamAuthTeamsResponseResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "CreateTeamAuthTeamsResponseResponseBody";
  }
}

/**
 * Unauthorized
 */
export type CreateTeamAuthTeamsResponseBodyData = {
  message: string;
};

/**
 * Unauthorized
 */
export class CreateTeamAuthTeamsResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: CreateTeamAuthTeamsResponseBodyData;

  constructor(
    err: CreateTeamAuthTeamsResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "CreateTeamAuthTeamsResponseBody";
  }
}

/**
 * Bad request
 */
export type CreateTeamResponseBodyData = {
  message: string;
};

/**
 * Bad request
 */
export class CreateTeamResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: CreateTeamResponseBodyData;

  constructor(
    err: CreateTeamResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "CreateTeamResponseBody";
  }
}

/** @internal */
export const CreateTeamAuthTeamsResponse429ResponseBody$inboundSchema:
  z.ZodType<CreateTeamAuthTeamsResponse429ResponseBody, z.ZodTypeDef, unknown> =
    z.object({
      message: z.string(),
      request$: z.instanceof(Request),
      response$: z.instanceof(Response),
      body$: z.string(),
    })
      .transform((v) => {
        return new CreateTeamAuthTeamsResponse429ResponseBody(v, {
          request: v.request$,
          response: v.response$,
          body: v.body$,
        });
      });

/** @internal */
export type CreateTeamAuthTeamsResponse429ResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const CreateTeamAuthTeamsResponse429ResponseBody$outboundSchema:
  z.ZodType<
    CreateTeamAuthTeamsResponse429ResponseBody$Outbound,
    z.ZodTypeDef,
    CreateTeamAuthTeamsResponse429ResponseBody
  > = z.instanceof(CreateTeamAuthTeamsResponse429ResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const CreateTeamAuthTeamsResponse409ResponseBody$inboundSchema:
  z.ZodType<CreateTeamAuthTeamsResponse409ResponseBody, z.ZodTypeDef, unknown> =
    z.object({
      message: z.string(),
      request$: z.instanceof(Request),
      response$: z.instanceof(Response),
      body$: z.string(),
    })
      .transform((v) => {
        return new CreateTeamAuthTeamsResponse409ResponseBody(v, {
          request: v.request$,
          response: v.response$,
          body: v.body$,
        });
      });

/** @internal */
export type CreateTeamAuthTeamsResponse409ResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const CreateTeamAuthTeamsResponse409ResponseBody$outboundSchema:
  z.ZodType<
    CreateTeamAuthTeamsResponse409ResponseBody$Outbound,
    z.ZodTypeDef,
    CreateTeamAuthTeamsResponse409ResponseBody
  > = z.instanceof(CreateTeamAuthTeamsResponse409ResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const CreateTeamAuthTeamsResponse404ResponseBody$inboundSchema:
  z.ZodType<CreateTeamAuthTeamsResponse404ResponseBody, z.ZodTypeDef, unknown> =
    z.object({
      message: z.string(),
      request$: z.instanceof(Request),
      response$: z.instanceof(Response),
      body$: z.string(),
    })
      .transform((v) => {
        return new CreateTeamAuthTeamsResponse404ResponseBody(v, {
          request: v.request$,
          response: v.response$,
          body: v.body$,
        });
      });

/** @internal */
export type CreateTeamAuthTeamsResponse404ResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const CreateTeamAuthTeamsResponse404ResponseBody$outboundSchema:
  z.ZodType<
    CreateTeamAuthTeamsResponse404ResponseBody$Outbound,
    z.ZodTypeDef,
    CreateTeamAuthTeamsResponse404ResponseBody
  > = z.instanceof(CreateTeamAuthTeamsResponse404ResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const CreateTeamAuthTeamsResponseResponseBody$inboundSchema: z.ZodType<
  CreateTeamAuthTeamsResponseResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  message: z.string(),
  request$: z.instanceof(Request),
  response$: z.instanceof(Response),
  body$: z.string(),
})
  .transform((v) => {
    return new CreateTeamAuthTeamsResponseResponseBody(v, {
      request: v.request$,
      response: v.response$,
      body: v.body$,
    });
  });

/** @internal */
export type CreateTeamAuthTeamsResponseResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const CreateTeamAuthTeamsResponseResponseBody$outboundSchema: z.ZodType<
  CreateTeamAuthTeamsResponseResponseBody$Outbound,
  z.ZodTypeDef,
  CreateTeamAuthTeamsResponseResponseBody
> = z.instanceof(CreateTeamAuthTeamsResponseResponseBody)
  .transform(v => v.data$)
  .pipe(z.object({
    message: z.string(),
  }));

/** @internal */
export const CreateTeamAuthTeamsResponseBody$inboundSchema: z.ZodType<
  CreateTeamAuthTeamsResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  message: z.string(),
  request$: z.instanceof(Request),
  response$: z.instanceof(Response),
  body$: z.string(),
})
  .transform((v) => {
    return new CreateTeamAuthTeamsResponseBody(v, {
      request: v.request$,
      response: v.response$,
      body: v.body$,
    });
  });

/** @internal */
export type CreateTeamAuthTeamsResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const CreateTeamAuthTeamsResponseBody$outboundSchema: z.ZodType<
  CreateTeamAuthTeamsResponseBody$Outbound,
  z.ZodTypeDef,
  CreateTeamAuthTeamsResponseBody
> = z.instanceof(CreateTeamAuthTeamsResponseBody)
  .transform(v => v.data$)
  .pipe(z.object({
    message: z.string(),
  }));

/** @internal */
export const CreateTeamResponseBody$inboundSchema: z.ZodType<
  CreateTeamResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  message: z.string(),
  request$: z.instanceof(Request),
  response$: z.instanceof(Response),
  body$: z.string(),
})
  .transform((v) => {
    return new CreateTeamResponseBody(v, {
      request: v.request$,
      response: v.response$,
      body: v.body$,
    });
  });

/** @internal */
export type CreateTeamResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const CreateTeamResponseBody$outboundSchema: z.ZodType<
  CreateTeamResponseBody$Outbound,
  z.ZodTypeDef,
  CreateTeamResponseBody
> = z.instanceof(CreateTeamResponseBody)
  .transform(v => v.data$)
  .pipe(z.object({
    message: z.string(),
  }));
